import type { Product, Variant } from '@scayle/storefront-nuxt'
import { useTrackingEvents } from '~/composables/useTrackingEvents'
import type { ListItem, WishlistLabelTypes } from '~/types/tracking'

export function useWishlistTracking() {
  const { trackRemoveFromWishlist, trackAddToWishlist, trackViewItemList } =
    useTrackingEvents()

  const trackWishlistItemEvent = (
    action: 'added' | 'removed',
    params: {
      product: Product
      listingMetaData?: ListItem
      variant?: Variant
      label: WishlistLabelTypes
    },
  ) => {
    const { product, listingMetaData, variant, label } = params
    if (!product) {
      return
    }

    const payload = {
      product,
      listingMetaData,
      label,
      ...(variant && { variant }),
    }

    return action === 'added'
      ? trackAddToWishlist(payload)
      : trackRemoveFromWishlist(payload)
  }

  const trackWishlistPage = (products: Product[]) => {
    // Note: Removed trackWishlist call as it was blocking execution
    // Only calling trackViewItemList to ensure the view_item_list event fires
    trackViewItemList({
      items: products.map((product, index) => ({
        ...product,
        index,
        item_list_id: 'Wishlist',
        item_list_name: 'Wishlist: individual list',
      })),
      listingMetaData: {
        id: 'Wishlist',
        name: 'Wishlist: individual list',
      },
      source: 'wishlist',
      pagePayload: {
        label: 'Wishlist',
        pageSize: products.length,
      },
    })
  }

  return {
    trackWishlistItemEvent,
    trackWishlistPage,
  }
}
